module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-button', {
    staticClass: "md-icon-button md-spinner"
  }, [_c('md-icon', [_vm._v("more_vert")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f02a5f5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Spinner.vue
// module id = 259
// module chunks = 1